import { menuItems } from '@peracto/peracto'

import {
    ROLE_SUPER_ADMIN,
    ROLE_ADMIN,
    ROLE_COMMERCIAL,
    ROLE_FINANCE,
    ROLE_MARKETING,
    ROLE_OPERATIONS,
    ROLE_TRADE_SUPPORT,
    PROMOTIONS_IMPORT_ROLES,
    LANDING_PAGES_IMPORT_ROLES,
    USER_IMPORT_ROLES,
    USER_EXPORT_ROLES,
} from '../constants/roles'

const {
    path: promotionsPath = '/promotions',
    children: promotionsChildren = {},
    ...promotionsMenu
} = menuItems.promotions ?? {}
const promotionsRoles = promotionsMenu.roles ?? [ROLE_ADMIN]

const menu = {
    ...menuItems,

    orders: {
        ...menuItems.orders,
        children: {
            allOrders: {
                label: 'Orders',
                path: '/orders',
                sortOrder: 10,
                roles: [ROLE_ADMIN],
            },
            orderRevenueExport: {
                label: 'Order Revenue Export',
                path: '/order-revenue-export',
                sortOrder: 20,
                roles: [ROLE_ADMIN],
            },
        },
    },

    products: {
        ...menuItems.products,

        children: {
            ...menuItems.products.children,
            productExports: {
                label: 'Product Exports',
                path: '/product-exports',
                sortOrder: 50,
                roles: [ROLE_ADMIN],
            },
        },
    },

    content: {
        ...menuItems.content,
        roles: [ROLE_SUPER_ADMIN, ROLE_ADMIN],

        children: {
            ...menuItems.content.children,
            landingPagesExport: {
                label: 'Landing Pages Export',
                path: '/landing-pages-export',
                sortOrder: 90,
                roles: [ROLE_ADMIN],
            },
            landingPagesBulkManageData: {
                label: 'Bulk Manage Data',
                path: '/manage-landing-pages-data',
                sortOrder: 91,
                roles: LANDING_PAGES_IMPORT_ROLES,
            },
            forms: {
                ...menuItems.content.children.forms,
                roles: [ROLE_SUPER_ADMIN, ROLE_MARKETING, ROLE_OPERATIONS],

                children: {
                    ...menuItems.content.children.forms.children,
                    allForms: {
                        ...menuItems.content.children.forms.children.allForms,
                        roles: [ROLE_SUPER_ADMIN, ROLE_MARKETING, ROLE_OPERATIONS],
                    },
                    formFields: {
                        ...menuItems.content.children.forms.children.formFields,
                        roles: [ROLE_SUPER_ADMIN, ROLE_MARKETING, ROLE_OPERATIONS],
                    },
                    formSubmissions: {
                        ...menuItems.content.children.forms.children.formSubmissions,
                        roles: [ROLE_SUPER_ADMIN, ROLE_MARKETING, ROLE_OPERATIONS],
                    },
                },
            },
        },
    },

    locations: {
        ...menuItems.locations,
        roles: [ROLE_SUPER_ADMIN, ROLE_FINANCE, ROLE_OPERATIONS],
    },

    promotions: {
        ...promotionsMenu,
        label: promotionsMenu.label ?? 'Promotions',
        roles: promotionsRoles,
        children: {
            ...promotionsChildren,
            allPromotions: {
                label: 'Promotions',
                path: promotionsPath,
                sortOrder: 10,
                roles: promotionsRoles,
            },
            promotionsExport: {
                label: 'Promotions Export',
                path: '/promotions-export',
                sortOrder: 100,
                roles: [ROLE_ADMIN],
            },
            bulkManageData: {
                label: 'Bulk Manage Data',
                path: '/manage-promotions-data',
                sortOrder: 20,
                roles: PROMOTIONS_IMPORT_ROLES,
            },
        },
    },

    users: {
        ...menuItems.users,
        children: {
            ...menuItems.users.children,
            bulkManageData: {
                label: 'Bulk Manage Data',
                path: '/manage-user-data',
                sortOrder: 25,
                roles: USER_IMPORT_ROLES,
            },
            userExport: {
                label: 'User Export',
                path: '/user-export',
                sortOrder: 30,
                roles: USER_EXPORT_ROLES,
            },
        },
    },

    configuration: {
        ...menuItems.configuration,
        roles: [ROLE_SUPER_ADMIN, ROLE_COMMERCIAL, ROLE_ADMIN],

        children: {
            ...menuItems.configuration.children,
            settings: {
                ...menuItems.configuration.children.settings,
                roles: [ROLE_SUPER_ADMIN, ROLE_TRADE_SUPPORT, ROLE_MARKETING, ROLE_OPERATIONS],
            },
            navigation: {
                label: 'Navigation',
                sortOrder: 20,
                roles: [ROLE_SUPER_ADMIN, ROLE_MARKETING, ROLE_COMMERCIAL, ROLE_OPERATIONS],
                children: {
                    menus: {
                        label: 'Menus',
                        path: '/menus',
                        sortOrder: 10,
                        roles: [ROLE_SUPER_ADMIN, ROLE_MARKETING, ROLE_COMMERCIAL, ROLE_OPERATIONS],
                    },
                    navigationExport: {
                        label: 'Navigation Export',
                        path: '/navigation-export',
                        sortOrder: 20,
                        roles: [ROLE_ADMIN],
                    },
                },
            },
            redirects: {
                ...menuItems.configuration.children.redirects,
                roles: [ROLE_SUPER_ADMIN, ROLE_TRADE_SUPPORT, ROLE_FINANCE, ROLE_OPERATIONS],
            },
            lastImportStatus: {
                label: 'Import Enquiry',
                path: '/last-imported-files',
                sortOrder: 60,
                roles: [ROLE_SUPER_ADMIN, ROLE_ADMIN, ROLE_COMMERCIAL],
            },
        },
    },
}

export default menu